import { createFileRoute } from '@tanstack/react-router';
import Alarms from '../../components/Alarms';
import { PERMISSION_ALARM } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/alarm/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_ALARM, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'menu.alarms',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: AlarmsRoute,
});

function AlarmsRoute() {
  return <Alarms />;
}
